export default "<div class=\"wrapper\">\n    <div class=\"content\" dir=\"ltr\" i18n-dir>\n          <router-outlet></router-outlet>\n    </div>\n</div>\n";